// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1A7Y_","inner":"Footer_inner__17DKw","nextIcon":"Footer_nextIcon__3cz-z","innerLeft":"Footer_innerLeft__1nwlr"};